// Carrega Cleave.js dinamicamente
var script = document.createElement('script');
script.src = 'https://cdn.jsdelivr.net/npm/cleave.js@1.6.0/dist/cleave.min.js';
script.onload = function() {
    console.log('[Cleave.js] Biblioteca carregada do CDN');
    window.initCleaveFields();
};
document.head.appendChild(script);

window.initCleaveFields = function(parent) {
    if (!parent) {
        parent = document.body;
    }

    // Aguarda um pouco para garantir que o Cleave está disponível
    setTimeout(function() {
        if (!window.Cleave) {
            console.error('[Cleave.js] Cleave não está disponível!');
            return;
        }

        const fields = parent.querySelectorAll('.money-cleave');
        console.log('[Cleave.js] Inicializando ' + fields.length + ' campos monetários');

        fields.forEach(function(el) {
            console.log('[Cleave.js] Inicializando campo:', el.name, el.id);

            if (!el.cleaveInstance) {
                el.cleaveInstance = new window.Cleave(el, {
                    numeral: true,
                    numeralIntegerScale: 10,
                    numeralDecimalScale: 2,
                    numeralDecimalMark: ',',
                    numeralThousandsGroupStyle: 'thousand',
                    delimiter: '.',
                    prefix: 'R$ ',
                    onValueChanged: function(sourceEvent) {
                        console.log('[Cleave.js] Valor mudou:', sourceEvent.target.value);
                    }
                });
                console.log('[Cleave.js] Campo inicializado com sucesso');
            }
        });
    }, 100);
};

// Inicializa ao carregar a página
document.addEventListener('DOMContentLoaded', function() {
    console.log('[Cleave.js] DOMContentLoaded disparado');
    window.initCleaveFields();
});
